const mutations = {
  setTypology(state, data) {
    state.typologyEdit = data
  },
  setDeleteTypology(state, data) {
    state.typologyDelete = data
  }
}

export default mutations